// import { useState, useEffect } from "react";
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
//   ResponsiveContainer, PieChart, Pie, Cell, Legend,
// } from "recharts";
// import {
//   FiFileText, FiDownload, FiUsers, FiTrendingUp,
//   FiRefreshCw, FiCalendar, FiMail, FiBookOpen,
//   FiArrowUpRight, FiArrowDownRight, FiClock, FiAlertCircle,
// } from "react-icons/fi";
// import { HiOutlineSparkles } from "react-icons/hi2";
// import "./Dashboard.css";

// /* ─── Color palette aligned to BaiRees design system ─────── */
// const PIE_COLORS  = ["#f5a623", "#0F4C5C", "#4FC3F7", "#A5D6A7"];
// const BAR_COLOR   = "#0F4C5C";
// const BAR_GOLD    = "#f5a623";

// /* ─── Custom Tooltip ─────────────────────────────────────── */
// const CustomTooltip = ({ active, payload, label }) => {
//   if (!active || !payload?.length) return null;
//   return (
//     <div className="db-tooltip">
//       <span className="db-tooltip__label">{label || payload[0].name}</span>
//       <span className="db-tooltip__value">{payload[0].value}</span>
//     </div>
//   );
// };

// /* ─── Animated counter ───────────────────────────────────── */
// function useCountUp(target, duration = 1200) {
//   const [count, setCount] = useState(0);
//   useEffect(() => {
//     if (!target) return;
//     let start = 0;
//     const step = Math.ceil(target / (duration / 16));
//     const timer = setInterval(() => {
//       start += step;
//       if (start >= target) { setCount(target); clearInterval(timer); }
//       else setCount(start);
//     }, 16);
//     return () => clearInterval(timer);
//   }, [target, duration]);
//   return count;
// }

// /* ─── Stat Card ──────────────────────────────────────────── */
// function StatCard({ icon, label, value, trend, trendLabel, accent, delay = 0 }) {
//   const displayed = useCountUp(value);
//   const isUp = trend >= 0;

//   return (
//     <div
//       className="db-stat"
//       style={{ "--accent": accent, animationDelay: `${delay}s` }}
//     >
//       <div className="db-stat__top">
//         <div className="db-stat__icon-wrap">{icon}</div>
//         {trend !== undefined && (
//           <div className={`db-stat__trend ${isUp ? "db-stat__trend--up" : "db-stat__trend--down"}`}>
//             {isUp ? <FiArrowUpRight /> : <FiArrowDownRight />}
//             <span>{Math.abs(trend)}%</span>
//           </div>
//         )}
//       </div>
//       <div className="db-stat__value">{displayed}</div>
//       <div className="db-stat__label">{label}</div>
//       {trendLabel && <div className="db-stat__trend-label">{trendLabel}</div>}
//       <div className="db-stat__bar" />
//     </div>
//   );
// }

// /* ─── Section Header ─────────────────────────────────────── */
// function SectionHead({ eyebrow, title }) {
//   return (
//     <div className="db-section-head">
//       <span className="db-eyebrow">{eyebrow}</span>
//       <h2 className="db-section-title">{title}</h2>
//     </div>
//   );
// }

// /* ═══════════════════════════════════════════════════════════
//    DASHBOARD
// ═══════════════════════════════════════════════════════════ */
// export default function Dashboard({ admin }) {
//   const [stats, setStats] = useState({
//     caseStudies: 0,
//     downloads: 0,
//     totalApplications: 0,
//     recentDownloads: [],
//     applications: {},
//   });
//   const [loading, setLoading]   = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [lastUpdated, setLastUpdated] = useState(null);

//   const fetchStats = async (isRefresh = false) => {
//     if (isRefresh) setRefreshing(true);
//     const token = localStorage.getItem("adminToken");
//     try {
//       const res  = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/stats`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data = await res.json();
//       if (data.success) {
//         setStats(data.data);
//         setLastUpdated(new Date());
//       }
//     } catch (err) {
//       console.error("Error fetching stats:", err);
//     } finally {
//       setLoading(false);
//       setRefreshing(false);
//     }
//   };

//   useEffect(() => { fetchStats(); }, []);

//   /* Chart data */
//   const overviewData = [
//     { name: "Case Studies", value: stats.caseStudies },
//     { name: "Downloads",    value: stats.downloads },
//     { name: "Applications", value: stats.totalApplications },
//   ];

//   const applicationData = [
//     { name: "Advisory",  value: stats.applications?.advisory  || 0 },
//     { name: "Business",  value: stats.applications?.business  || 0 },
//     { name: "Delivery",  value: stats.applications?.delivery  || 0 },
//     { name: "Employee",  value: stats.applications?.employee  || 0 },
//   ];

//   const totalApps = applicationData.reduce((s, d) => s + d.value, 0);

//   /* ── Loading ── */
//   if (loading) return (
//     <div className="db-loading">
//       <div className="db-loading__spinner" />
//       <span>Loading dashboard…</span>
//     </div>
//   );

//   /* ── Render ── */
//   return (
//     <div className="db">

//       {/* ── HEADER ─────────────────────────────────────────── */}
//       <header className="db-header">
//         <div className="db-header__left">
//           <span className="db-eyebrow">
//             <HiOutlineSparkles className="db-eyebrow__icon" />
//             Admin Console
//           </span>
//           <h1 className="db-header__title">
//             Welcome back, <span>{admin?.username || "Admin"}</span>
//           </h1>
//           <p className="db-header__sub">
//             Here's what's happening across your platform today.
//           </p>
//         </div>

//         <div className="db-header__right">
//           {lastUpdated && (
//             <div className="db-header__timestamp">
//               <FiClock />
//               Updated {lastUpdated.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
//             </div>
//           )}
//           <button
//             className={`db-refresh ${refreshing ? "db-refresh--spinning" : ""}`}
//             onClick={() => fetchStats(true)}
//             disabled={refreshing}
//             title="Refresh data"
//           >
//             <FiRefreshCw />
//             <span>{refreshing ? "Refreshing…" : "Refresh"}</span>
//           </button>
//         </div>
//       </header>

//       {/* ── KPI CARDS ──────────────────────────────────────── */}
//       <section className="db-kpis">
//         <StatCard
//           icon={<FiFileText />}
//           label="Case Studies"
//           value={stats.caseStudies}
//           trend={12}
//           trendLabel="vs last month"
//           accent="#f5a623"
//           delay={0}
//         />
//         <StatCard
//           icon={<FiDownload />}
//           label="Total Downloads"
//           value={stats.downloads}
//           trend={8}
//           trendLabel="vs last month"
//           accent="#4FC3F7"
//           delay={0.08}
//         />
//         <StatCard
//           icon={<FiUsers />}
//           label="Applications"
//           value={stats.totalApplications}
//           trend={-3}
//           trendLabel="vs last month"
//           accent="#A5D6A7"
//           delay={0.16}
//         />
//         <StatCard
//           icon={<FiTrendingUp />}
//           label="Engagement Score"
//           value={Math.round((stats.downloads / Math.max(stats.caseStudies, 1)) * 10)}
//           accent="#CE93D8"
//           delay={0.24}
//         />
//       </section>

//       {/* ── CHARTS ─────────────────────────────────────────── */}
//       <section className="db-charts">

//         {/* Bar chart */}
//         <div className="db-chart-box">
//           <SectionHead eyebrow="Overview" title="Platform Activity" />
//           <div className="db-chart-wrap">
//             <ResponsiveContainer width="100%" height={260}>
//               <BarChart data={overviewData} barSize={36}>
//                 <CartesianGrid strokeDasharray="3 3" stroke="rgba(1,13,29,0.06)" />
//                 <XAxis
//                   dataKey="name"
//                   tick={{ fontSize: 12, fill: "rgba(1,13,29,0.5)", fontFamily: "Inter" }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <YAxis
//                   tick={{ fontSize: 12, fill: "rgba(1,13,29,0.4)", fontFamily: "Inter" }}
//                   axisLine={false}
//                   tickLine={false}
//                 />
//                 <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(15,76,92,0.05)" }} />
//                 <Bar dataKey="value" fill={BAR_COLOR} radius={[6, 6, 0, 0]}>
//                   {overviewData.map((_, i) => (
//                     <Cell key={i} fill={i === 1 ? BAR_GOLD : BAR_COLOR} />
//                   ))}
//                 </Bar>
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Pie chart */}
//         <div className="db-chart-box">
//           <SectionHead eyebrow="Applications" title="Partner Type Breakdown" />
//           <div className="db-chart-wrap db-chart-wrap--pie">
//             <ResponsiveContainer width="100%" height={260}>
//               <PieChart>
//                 <Pie
//                   data={applicationData}
//                   cx="50%"
//                   cy="50%"
//                   innerRadius={70}
//                   outerRadius={110}
//                   paddingAngle={4}
//                   dataKey="value"
//                 >
//                   {applicationData.map((_, i) => (
//                     <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} stroke="none" />
//                   ))}
//                 </Pie>
//                 <Tooltip content={<CustomTooltip />} />
//               </PieChart>
//             </ResponsiveContainer>

//             {/* Centre label */}
//             <div className="db-pie-centre">
//               <span className="db-pie-centre__num">{totalApps}</span>
//               <span className="db-pie-centre__label">Total</span>
//             </div>

//             {/* Legend */}
//             <div className="db-pie-legend">
//               {applicationData.map((d, i) => (
//                 <div key={d.name} className="db-pie-legend__item">
//                   <span className="db-pie-legend__dot" style={{ background: PIE_COLORS[i] }} />
//                   <span className="db-pie-legend__name">{d.name}</span>
//                   <span className="db-pie-legend__val">{d.value}</span>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* ── RECENT DOWNLOADS ───────────────────────────────── */}
//       <section className="db-table-section">
//         <div className="db-table-header">
//           <SectionHead eyebrow="Activity" title="Recent Downloads" />
//           <button className="db-view-all">
//             View All <FiArrowUpRight />
//           </button>
//         </div>

//         <div className="db-table-wrap">
//           {stats.recentDownloads.length === 0 ? (
//             <div className="db-empty">
//               <FiAlertCircle className="db-empty__icon" />
//               <p>No downloads recorded yet.</p>
//             </div>
//           ) : (
//             <table className="db-table">
//               <thead>
//                 <tr>
//                   <th><FiUsers className="db-th-icon" /> Name</th>
//                   <th><FiMail className="db-th-icon" /> Email</th>
//                   <th><FiBookOpen className="db-th-icon" /> Case Study</th>
//                   <th><FiCalendar className="db-th-icon" /> Date</th>
//                   <th>Status</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {stats.recentDownloads.map((dl, i) => (
//                   <tr key={i} style={{ animationDelay: `${i * 0.04}s` }}>
//                     <td>
//                       <div className="db-table__name">
//                         <div className="db-avatar">
//                           {dl.name?.charAt(0).toUpperCase() || "?"}
//                         </div>
//                         {dl.name}
//                       </div>
//                     </td>
//                     <td className="db-table__email">{dl.email}</td>
//                     <td>
//                       <span className="db-table__study">
//                         {dl.caseStudyId?.title || "Unknown"}
//                       </span>
//                     </td>
//                     <td className="db-table__date">
//                       {new Date(dl.downloadedAt).toLocaleDateString("en-IN", {
//                         day: "numeric", month: "short", year: "numeric",
//                       })}
//                     </td>
//                     <td>
//                       <span className="db-badge db-badge--success">Completed</span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           )}
//         </div>
//       </section>

//     </div>
//   );
// }










import { useState, useEffect } from "react";
import { useStore } from "../../hooks/useStore";
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip,
  ResponsiveContainer, PieChart, Pie, Cell,
} from "recharts";
import {
  FiFileText, FiDownload, FiUsers, FiTrendingUp,
  FiRefreshCw, FiCalendar, FiMail, FiBookOpen,
  FiArrowUpRight, FiArrowDownRight, FiClock, FiAlertCircle,
} from "react-icons/fi";
import { HiOutlineSparkles } from "react-icons/hi2";
import "./Dashboard.css";

/* ─── Color palette aligned to BaiRees design system ─────── */
const PIE_COLORS  = ["#f5a623", "#0F4C5C", "#4FC3F7", "#A5D6A7"];
const BAR_COLOR   = "#0F4C5C";
const BAR_GOLD    = "#f5a623";

/* ─── Custom Tooltip ─────────────────────────────────────── */
const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="db-tooltip">
      <span className="db-tooltip__label">{label || payload[0].name}</span>
      <span className="db-tooltip__value">{payload[0].value}</span>
    </div>
  );
};

/* ─── Animated counter ───────────────────────────────────── */
function useCountUp(target, duration = 1200) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!target) return;
    let start = 0;
    const step = Math.ceil(target / (duration / 16));
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(start);
    }, 16);
    return () => clearInterval(timer);
  }, [target, duration]);
  return count;
}

/* ─── Stat Card ──────────────────────────────────────────── */
function StatCard({ icon, label, value, trend, trendLabel, accent, delay = 0 }) {
  const displayed = useCountUp(value);
  const isUp = trend >= 0;

  return (
    <div
      className="db-stat"
      style={{ "--accent": accent, animationDelay: `${delay}s` }}
    >
      <div className="db-stat__top">
        <div className="db-stat__icon-wrap">{icon}</div>
        {trend !== undefined && (
          <div className={`db-stat__trend ${isUp ? "db-stat__trend--up" : "db-stat__trend--down"}`}>
            {isUp ? <FiArrowUpRight /> : <FiArrowDownRight />}
            <span>{Math.abs(trend)}%</span>
          </div>
        )}
      </div>
      <div className="db-stat__value">{displayed}</div>
      <div className="db-stat__label">{label}</div>
      {trendLabel && <div className="db-stat__trend-label">{trendLabel}</div>}
      <div className="db-stat__bar" />
    </div>
  );
}

/* ─── Section Header ─────────────────────────────────────── */
function SectionHead({ eyebrow, title }) {
  return (
    <div className="db-section-head">
      <span className="db-eyebrow">{eyebrow}</span>
      <h2 className="db-section-title">{title}</h2>
    </div>
  );
}

/* ═══════════════════════════════════════════════════════════
   DASHBOARD
═══════════════════════════════════════════════════════════ */
export default function Dashboard() {
  const { admin, token } = useStore();
  
  const [stats, setStats] = useState({
    caseStudies: 0,
    downloads: 0,
    totalApplications: 0,
    recentDownloads: [],
    applications: {},
  });
  const [loading, setLoading]   = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [lastUpdated, setLastUpdated] = useState(null);

  const fetchStats = async (isRefresh = false) => {
    if (isRefresh) setRefreshing(true);
    try {
      const res  = await fetch(`${import.meta.env.VITE_API_URL}/api/admin/stats`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) {
        setStats(data.data);
        setLastUpdated(new Date());
      }
    } catch (err) {
      console.error("Error fetching stats:", err);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  };

  useEffect(() => { 
    if (token) {
      fetchStats(); 
    }
  }, [token]);

  /* Chart data */
  const overviewData = [
    { name: "Case Studies", value: stats.caseStudies },
    { name: "Downloads",    value: stats.downloads },
    { name: "Applications", value: stats.totalApplications },
  ];

  const applicationData = [
    { name: "Advisory",  value: stats.applications?.advisory  || 0 },
    { name: "Business",  value: stats.applications?.business  || 0 },
    { name: "Delivery",  value: stats.applications?.delivery  || 0 },
    { name: "Employee",  value: stats.applications?.employee  || 0 },
  ];

  const totalApps = applicationData.reduce((s, d) => s + d.value, 0);

  /* ── Loading ── */
  if (loading) return (
    <div className="db-loading">
      <div className="db-loading__spinner" />
      <span>Loading dashboard…</span>
    </div>
  );

  /* ── Render ── */
  return (
    <div className="db">

      {/* ── HEADER ─────────────────────────────────────────── */}
      <header className="db-header">
        <div className="db-header__left">
          <span className="db-eyebrow">
            <HiOutlineSparkles className="db-eyebrow__icon" />
            Admin Console
          </span>
          <h1 className="db-header__title">
            Welcome back, <span>{admin?.username || "Admin"}</span>
          </h1>
          <p className="db-header__sub">
            Here's what's happening across your platform today.
          </p>
        </div>

        <div className="db-header__right">
          {lastUpdated && (
            <div className="db-header__timestamp">
              <FiClock />
              Updated {lastUpdated.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
            </div>
          )}
          <button
            className={`db-refresh ${refreshing ? "db-refresh--spinning" : ""}`}
            onClick={() => fetchStats(true)}
            disabled={refreshing}
            title="Refresh data"
          >
            <FiRefreshCw />
            <span>{refreshing ? "Refreshing…" : "Refresh"}</span>
          </button>
        </div>
      </header>

      {/* ── KPI CARDS ──────────────────────────────────────── */}
      <section className="db-kpis">
        <StatCard
          icon={<FiFileText />}
          label="Case Studies"
          value={stats.caseStudies}
          trend={12}
          trendLabel="vs last month"
          accent="#f5a623"
          delay={0}
        />
        <StatCard
          icon={<FiDownload />}
          label="Total Downloads"
          value={stats.downloads}
          trend={8}
          trendLabel="vs last month"
          accent="#4FC3F7"
          delay={0.08}
        />
        <StatCard
          icon={<FiUsers />}
          label="Applications"
          value={stats.totalApplications}
          trend={-3}
          trendLabel="vs last month"
          accent="#A5D6A7"
          delay={0.16}
        />
        <StatCard
          icon={<FiTrendingUp />}
          label="Engagement Score"
          value={Math.round((stats.downloads / Math.max(stats.caseStudies, 1)) * 10)}
          accent="#CE93D8"
          delay={0.24}
        />
      </section>

      {/* ── CHARTS ─────────────────────────────────────────── */}
      <section className="db-charts">

        {/* Bar chart */}
        <div className="db-chart-box">
          <SectionHead eyebrow="Overview" title="Platform Activity" />
          <div className="db-chart-wrap">
            <ResponsiveContainer width="100%" height={260}>
              <BarChart data={overviewData} barSize={36}>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(1,13,29,0.06)" />
                <XAxis
                  dataKey="name"
                  tick={{ fontSize: 12, fill: "rgba(1,13,29,0.5)", fontFamily: "Inter" }}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fontSize: 12, fill: "rgba(1,13,29,0.4)", fontFamily: "Inter" }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(15,76,92,0.05)" }} />
                <Bar dataKey="value" fill={BAR_COLOR} radius={[6, 6, 0, 0]}>
                  {overviewData.map((_, i) => (
                    <Cell key={i} fill={i === 1 ? BAR_GOLD : BAR_COLOR} />
                  ))}
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie chart */}
        <div className="db-chart-box">
          <SectionHead eyebrow="Applications" title="Partner Type Breakdown" />
          <div className="db-chart-wrap db-chart-wrap--pie">
            <ResponsiveContainer width="100%" height={260}>
              <PieChart>
                <Pie
                  data={applicationData}
                  cx="50%"
                  cy="50%"
                  innerRadius={70}
                  outerRadius={110}
                  paddingAngle={4}
                  dataKey="value"
                >
                  {applicationData.map((_, i) => (
                    <Cell key={i} fill={PIE_COLORS[i % PIE_COLORS.length]} stroke="none" />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>

            {/* Centre label */}
            <div className="db-pie-centre">
              <span className="db-pie-centre__num">{totalApps}</span>
              <span className="db-pie-centre__label">Total</span>
            </div>

            {/* Legend */}
            <div className="db-pie-legend">
              {applicationData.map((d, i) => (
                <div key={d.name} className="db-pie-legend__item">
                  <span className="db-pie-legend__dot" style={{ background: PIE_COLORS[i] }} />
                  <span className="db-pie-legend__name">{d.name}</span>
                  <span className="db-pie-legend__val">{d.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── RECENT DOWNLOADS ───────────────────────────────── */}
      <section className="db-table-section">
        <div className="db-table-header">
          <SectionHead eyebrow="Activity" title="Recent Downloads" />
          <button className="db-view-all">
            View All <FiArrowUpRight />
          </button>
        </div>

        <div className="db-table-wrap">
          {stats.recentDownloads.length === 0 ? (
            <div className="db-empty">
              <FiAlertCircle className="db-empty__icon" />
              <p>No downloads recorded yet.</p>
            </div>
          ) : (
            <table className="db-table">
              <thead>
                <tr>
                  <th><FiUsers className="db-th-icon" /> Name</th>
                  <th><FiMail className="db-th-icon" /> Email</th>
                  <th><FiBookOpen className="db-th-icon" /> Case Study</th>
                  <th><FiCalendar className="db-th-icon" /> Date</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {stats.recentDownloads.map((dl, i) => (
                  <tr key={i} style={{ animationDelay: `${i * 0.04}s` }}>
                    <td>
                      <div className="db-table__name">
                        <div className="db-avatar">
                          {dl.name?.charAt(0).toUpperCase() || "?"}
                        </div>
                        {dl.name}
                      </div>
                    </td>
                    <td className="db-table__email">{dl.email}</td>
                    <td>
                      <span className="db-table__study">
                        {dl.caseStudyId?.title || "Unknown"}
                      </span>
                    </td>
                    <td className="db-table__date">
                      {new Date(dl.downloadedAt).toLocaleDateString("en-IN", {
                        day: "numeric", month: "short", year: "numeric",
                      })}
                    </td>
                    <td>
                      <span className="db-badge db-badge--success">Completed</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </section>

    </div>
  );
}